module.exports = __webpack_public_path__ + "assets/img/img11.19c31001.png";